import React, { useMemo, useState } from 'react'
import { useGetObjectsInResourceGroupQuery } from '../../../../services/objects';
import { EnergyRatesList, IEnergyRate } from '../../../Energy/EnergyRates';
import { LoadingView } from '../../../../components';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ROLE, SIZE } from "baseui/modal";
import { FormattedMessage, useIntl } from 'react-intl';
import { EmptyState } from '../../../../components/EmptyState';
import { useGetBuilding } from '../../../../hooks/useGetBuilding';
import { Link } from 'react-router-dom';
import { StyledLink } from 'baseui/link';
import { useStyletron } from 'baseui';
import { GetObjectUrl } from '../../../../utils/navigationService';

const SelectRateListModal = (props: { resourceGroupId: string, id: string, isOpen: boolean, onClose: () => void, modelToReference: string, onSubmit: (item?: IEnergyRate) => void, isSubmitting: boolean }) => {
    const [selectedItem, setSeletctedItem] = useState<IEnergyRate>();

    const { data, isLoading, isSuccess } = useGetObjectsInResourceGroupQuery({ resourceGroupId: props.resourceGroupId, queryParameters: `modelId=${props.modelToReference}` })
    const items = useMemo(() => data?.slice().sort((a, b) => a.name.localeCompare(b.name)), [data])

    const handelItemSelected = (item: IEnergyRate) => setSeletctedItem(item);
    const handleClose = () => { props.onClose() }

    return (
        <Modal
            onClose={handleClose}
            closeable
            isOpen={props.isOpen}
            animate
            autoFocus
            size={SIZE.default}
            role={ROLE.dialog}
        >
            <ModalHeader><FormattedMessage id="SelectRateListModal.header" defaultMessage="Link energy rate"></FormattedMessage></ModalHeader>
            <ModalBody>
                <LoadingView isLoading={isLoading} isSucess={isSuccess}>
                    <EnergyRatesList items={items ?? []} onSelect={handelItemSelected} selectedItem={selectedItem}></EnergyRatesList>
                    {(!items || items.length === 0) && <MyEmptyState objectId={props.id} resourceGroupId={props.resourceGroupId} />}
                </LoadingView>
            </ModalBody>
            <ModalFooter>
                <ModalButton kind={'tertiary'} onClick={handleClose}>
                    <FormattedMessage id="cancel" defaultMessage="Cancel"></FormattedMessage>
                </ModalButton>
                <ModalButton onClick={() => props.onSubmit(selectedItem)} disabled={!selectedItem} isLoading={props.isSubmitting}>
                    <FormattedMessage id="ok" defaultMessage="Ok"></FormattedMessage>
                </ModalButton>
            </ModalFooter>
        </Modal>
    )
}


export default SelectRateListModal

const MyEmptyState = (props: { objectId, resourceGroupId }) => {
    const [css,] = useStyletron()
    const intl = useIntl();
    const { item } = useGetBuilding(props.objectId, props.resourceGroupId);

    return (
        <EmptyState header={intl.formatMessage({id: "EditableEnergyRatesList.NoRates", defaultMessage: 'No energy rates found'})} >
            <FormattedMessage id="Counter.AddRatesAtBuilding" defaultMessage={"Add rates in your Building's Configuration window"} ></FormattedMessage>
            
            {item && <Link to={`${GetObjectUrl(item.resourceGroupId, item.id)}?defaultView=configuration`} className={css({ textDecoration: 'none' })}>
                <StyledLink animateUnderline ><FormattedMessage id="configuration" defaultMessage="Configuration" /></StyledLink>
            </Link>}
        </EmptyState>
    )
}
//onClick={handleOkClick} isLoading={createObjectResult.isLoading}